import api from "./api";
import { useCommonStore } from "@/stores/utility/common-store2";

export default {
  _user: null,
  _role: null,
  _permission: null,
  async getUserInitial() {
    try {
      const userId = localStorage.getItem("user_id");
      // const response = await api.get('user');

      const response = await api.get("users/" + userId);

      this._user = response.data;
      this._role = response.data.roles[0];
      this._permission = this._role.permissions;

      // await this.getRole();
      // await this.getPermission();
      return {
        isOk: true,
        data: response.data,
      };
    } catch (error) {
      return {
        isOk: false,
        message: error.response.data.message,
      };
    }
  },

  // async getRole() {
  //   console.log("hello from auth.js/getRole")
  //   try {
  //     // const response = await api.get('roles/'+this._user.id);
  //     const response = await api.get('getRole/'+this._user.id);
  //     this._role = response.data;
  //     return {
  //       isOk: true,
  //       data: response.data
  //     };
  //   } catch (error) {
  //     return {
  //       isOk: false,
  //       message: error.response.data.message
  //     };
  //   }
  // },

  // async getPermission() {
  //   console.log("hello from auth.js/getPermission")
  //   try {
  //     const response = await api.get('getPermission/'+this._role.id);
  //     this._permission = response.data;
  //     return {
  //       isOk: true,
  //       data: response.data
  //     };
  //   } catch (error) {
  //     return {
  //       isOk: false,
  //       message: error.response.data.message
  //     };
  //   }
  // },

  getUser() {
    if (this._user) {
      return this._user;
    }
    return null;
  },

  getUserRole() {
    if (this._role) {
      return this._role;
    }
    return null;
  },
  getUserPermission() {
    if (this._permission) {
      return this._permission;
    }
    return null;
  },

  async logIn(email, password) {
    try {
      const response = await api.post("login", {
        email,
        password,
      });

      const { access_token } = response.data;
      const { user_id } = response.data;
      localStorage.setItem("auth_token", access_token);
      localStorage.setItem("user_id", user_id);
      api.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;

      const userResponse = await this.getUserInitial();
      return {
        isOk: true,
        data: userResponse.data,
      };
    } catch (error) {
      return {
        isOk: false,
        message: error.response.data.message,
      };
    }
  },

  async confirmPassword(email, password) {
    try {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "multipart/form-data",
        },
      };

      const response = await api.post(
        "confirm_password",
        {
          email,
          password,
        },
        config,
      );

      return {
        isOk: true,
        data: response.data,
      };
    } catch (error) {
      return {
        isOk: false,
        message: error.response.data.message,
      };
    }
  },

  async logOut() {
    try {
      useCommonStore().clearStore();
      const token = localStorage.getItem("auth_token");
      if (token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      } //ini nanti di test yaa
      await api.post("logout");
      localStorage.removeItem("auth_token");
      localStorage.removeItem("user_id");
      delete api.defaults.headers.common["Authorization"];
      this._user = null;
      return {
        isOk: true,
      };
    } catch (error) {
      return {
        isOk: false,
        message: error.response.data.message,
      };
    }
  },

  async resetPassword(email) {
    try {
      const response = await api.post("reset-password", {
        email,
      });
      return {
        status: response.status,
        isOk: true,
        message: response.data.message,
        notify_type: response.data.notify_type,
      };
    } catch (error) {
      return {
        status: error.response.status,
        isOk: false,
        message: error.response.data.message,
        notify_type: error.response.data.notify_type,
      };
    }
  },

  async changePassword(email, recoveryCode, password) {
    try {
      const response = await api.post("reset-password", {
        email,
        recovery_code: recoveryCode,
        password,
      });
      return {
        isOk: true,
        message: response.data.message,
      };
    } catch (error) {
      return {
        isOk: false,
        message: error.response.data.message,
      };
    }
  },

  async createAccount(name, email, password) {
    try {
      const response = await api.post("register", {
        name,
        email,
        password,
      });
      const { token } = response.data;
      localStorage.setItem("auth_token", token);
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      const userResponse = await this.getUserInitial();
      return {
        isOk: true,
        data: userResponse.data,
      };
    } catch (error) {
      return {
        isOk: false,
        message: error.response.data.message,
      };
    }
  },

  async loggedIn() {
    const authToken = localStorage.getItem("auth_token");
    if (authToken) {
      api.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
      if ((await this.getUserInitial()).isOk) {
        return !!this._user;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
};

/*
const defaultUser = {
  email: 'sandra@example.com',
  avatarUrl: 'https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/employees/06.png'
};

export default {
  _user: defaultUser,
  loggedIn() {
    return !!this._user;
  },

  async logIn(email, password) {
    try {
      // Send request
      this._user = { ...defaultUser, email };

      return {
        isOk: true,
        data: this._user
      };
    }
    catch {
      return {
        isOk: false,
        message: "Authentication failed"
      };
    }
  },

  async logOut() {
    this._user = null;
  },

  async getUser() {
    try {
      // Send request

      return {
        isOk: true,
        data: this._user
      };
    }
    catch {
      return {
        isOk: false
      };
    }
  },

  async resetPassword(email) {
    try {
      // Send request
      console.log(email);

      return {
        isOk: true
      };
    }
    catch {
      return {
        isOk: false,
        message: "Failed to reset password"
      };
    }
  },

  async changePassword(email, recoveryCode) {
    try {
      // Send request
      console.log(email, recoveryCode);

      return {
        isOk: true
      };
    }
    catch {
      return {
        isOk: false,
        message: "Failed to change password"
      }
    }
  },

  async createAccount(email, password) {
    try {
      // Send request
      console.log(email, password);

      return {
        isOk: true
      };
    }
    catch {
      return {
        isOk: false,
        message: "Failed to create account"
      };
    }
  }
};
*/

// const defaultUser = {
//   email: 'sandra@example.com',
//   avatarUrl: 'https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/employees/06.png'
// };

// export default {
//   _user: defaultUser,
//   loggedIn() {
//     return !!this._user;
//   },

//   async logIn(email, password) {
//     try {
//       // Send request
//       console.log(email, password);
//       this._user = { ...defaultUser, email };

//       return {
//         isOk: true,
//         data: this._user
//       };
//     }
//     catch {
//       return {
//         isOk: false,
//         message: "Authentication failed"
//       };
//     }
//   },

//   async logOut() {
//     this._user = null;
//   },

//   async getUser() {
//     try {
//       // Send request

//       return {
//         isOk: true,
//         data: this._user
//       };
//     }
//     catch {
//       return {
//         isOk: false
//       };
//     }
//   },

//   async resetPassword(email) {
//     try {
//       // Send request
//       console.log(email);

//       return {
//         isOk: true
//       };
//     }
//     catch {
//       return {
//         isOk: false,
//         message: "Failed to reset password"
//       };
//     }
//   },

//   async changePassword(email, recoveryCode) {
//     try {
//       // Send request
//       console.log(email, recoveryCode);

//       return {
//         isOk: true
//       };
//     }
//     catch {
//       return {
//         isOk: false,
//         message: "Failed to change password"
//       }
//     }
//   },

//   async createAccount(email, password) {
//     try {
//       // Send request
//       console.log(email, password);

//       return {
//         isOk: true
//       };
//     }
//     catch {
//       return {
//         isOk: false,
//         message: "Failed to create account"
//       };
//     }
//   }
// };
